import {GET_ENTITIES_BY_FILTER} from "../actions/actionsEntities";

const initialState = {
    list: [],
    totalRecords: 0,
    metadata: {
        pagNum: 0,
        numElements: 0,
        filterApplied:  undefined,
        geo:{
            viewport: undefined,
            location:{
                center: undefined
            }
        },
    }
};

export function reducerEntities(state = initialState, action) {
    
    switch (action.type) {
        case GET_ENTITIES_BY_FILTER:
            return Object.assign({}, state, {
                list: action.payload.result,
                totalRecords: action.payload.totalRecords,
                metadata: action.payload.metadata,
            });
        
        default:
            return state
    }
}